var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWealth105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5 9C19.2533 9 15 13.2533 15 18.5C15 23.7467 19.2533 28 24.5 28C29.7467 28 34 23.7467 34 18.5C34 13.2533 29.7467 9 24.5 9ZM14 18.5C14 12.701 18.701 8 24.5 8C30.299 8 35 12.701 35 18.5C35 24.299 30.299 29 24.5 29C18.701 29 14 24.299 14 18.5ZM35 39H66.5C66.7761 39 67 38.7761 67 38.5C67 38.2239 66.7761 38 66.5 38H34.5H18.5C16.2457 38 14.0837 38.8955 12.4896 40.4896C10.8955 42.0837 10 44.2457 10 46.5V96.5C10 96.7761 10.2239 97 10.5 97C10.7761 97 11 96.7761 11 96.5V46.5C11 44.5109 11.7902 42.6032 13.1967 41.1967C14.6032 39.7902 16.5109 39 18.5 39H34V96.5C34 96.7761 34.2239 97 34.5 97C34.7761 97 35 96.7761 35 96.5V39Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57 8.5C57 8.22386 56.7761 8 56.5 8C56.2239 8 56 8.22386 56 8.5V16H46.5C46.2239 16 46 16.2239 46 16.5C46 16.7761 46.2239 17 46.5 17H56.5H94V68H70.5006H70.4992H46.5C46.2239 68 46 68.2239 46 68.5C46 68.7761 46.2239 69 46.5 69H70.1704L82.0406 96.6971C82.1493 96.9509 82.4433 97.0685 82.6971 96.9597C82.9509 96.8509 83.0685 96.557 82.9597 96.3032L71.2583 69H94.5C94.7761 69 95 68.7761 95 68.5V16.5C95 16.2239 94.7761 16 94.5 16H57V8.5Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgWealth105;